import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { FormInputSelect, HeaderTwo } from 'secondstep-components'

export const ProgramRoleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: -0.375rem;
  margin-bottom: 1.25rem;
`

export const ProgramRoleHeader = styled(HeaderTwo)`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
  text-align: start;
  margin-bottom: 1.063rem;
`

export const FieldQuestionLabel = styled.label`
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  line-height: ${themeGet('spacing.turquoise20_1_25rem')};
  color: ${themeGet('colors.darkGray')};
  margin-bottom: 0.563rem;
`

export const SelectField = styled(FormInputSelect)`
  width: 100%;
  margin-bottom: ${themeGet('spacing.turquoise20_1_25rem')};
  button {
    height: 43px;
    border: 1.5px solid ${themeGet('colors.blueGrayMedium')};
  }
  label {
    font-family: ${themeGet('font.molde.medium')};
    font-size: 0.75rem;
    line-height: ${themeGet('spacing.turquoise20_1_25rem')};
  }

  label,
  input {
    color: ${themeGet('colors.darkGray')};
  }

  &:first-of-type {
    margin-bottom: 1.5rem;
  }
`
